import styled from 'styled-components';

import { CalciteIcon } from 'components/Calcite';

interface StyledCheckIconProps {
  selected?: boolean;
}
export const StyledCheckIcon = styled(CalciteIcon).attrs<StyledCheckIconProps>({
  icon: 'check'
})<StyledCheckIconProps>`
  vertical-align: middle;
  color: ${props => (props.selected ? '#48e2cb' : '#cacaca')};
`;
